import * as React from 'react'

import { styled, theme } from '../theme'

export interface SpinnerProps {
  className?: string
  style?: React.CSSProperties
  size?: 'default' | 'small' | 'big'
  variant?: 'default' | 'primary' | 'danger'
}

export class Spinner extends React.Component<SpinnerProps, {}> {
  static defaultProps = {
    size: 'default',
    variant: 'default',
  }
  render() {
    const { size, variant, className, style } = this.props
    const {} = this.props
    return (
      <Wrapper
        className={className}
        data-size={size ? size : 'default'}
        data-variant={variant ? variant : 'default'}
        style={style}
      />
    )
  }
}

const Wrapper = styled.div`
  display: inline-block;
  width: 25px;
  height: 25px;
  border: 5px solid ${theme.colors.borderColor1};
  border-radius: 50%;
  border-top-color: ${theme.colors.secondary};
  animation: spin 0.8s ease-in-out infinite;
  &[data-size='big'] {
    width: 50px;
    height: 50px;
    border-width: 10px;
  }
  &[data-size='small'] {
    width: 15px;
    height: 15px;
    border-width: 4px;
  }
  &[data-variant='primary'] {
    border-top-color: ${theme.colors.primary};
  }
  &[data-variant='danger'] {
    border-top-color: ${theme.colors.danger};
  }
  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`
